import React from "react";
import _pubBab5A68F, {Preview as _pubBab5A68F_Preview} from "./utils.pc";
import _pubA97D53F3 from "./atoms.pc";
import "./Progress.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var $$Default = React.memo(React.forwardRef(function $$Default(props, ref) {
  return React.createElement("div", {
    "className": "_25aed9b9 _9fdd11dd _pub-9fdd11dd _pub-a97d53f3",
    "ref": ref,
    "style": castStyle("--value: " + props["value"] + ";"),
  }, 
    React.createElement("div", {
      "className": "_632c43bf _9fdd11dd _pub-9fdd11dd _pub-a97d53f3",
    }, null)
  )
}));
export default $$Default;


